// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-header {
  position: relative;
  height: 56px;
  display: flex;
  align-items: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  background-color: var(--planeed-color-white);
}

.back-icon {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--planeed-blue);
  padding-left: 20px;
  cursor: pointer;
}
.back-icon ion-icon {
  margin-left: 10px;
  display: flex;
  height: 12px;
  margin-bottom: 1px;
}

.panel-icon {
  margin-right: 10px;
}

.side-panel-headline {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  color: var(--ion-color-secondary);
}

@media (max-width: 460px) {
  .panel-header {
    display: none;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
